import { FormInstance } from 'antd';
import {
  DataObjectGroupType,
  DirectoryFilter,
  DirectoryFilterProps,
  useDataObjectGroupsWithDescriptionsQuery,
  useGroupDescriptionOptions,
} from '@atlas-frontend/sdk';
import { forwardRef, useMemo } from 'react';
import { DataManagerSelect } from './DataManagerSelect';
import { GroupOrDescriptionSelect } from '../GroupOrDescriptionSelect';
import { i18nNsFactory } from '@atlas-frontend/i18n';
import translations from './InputDataDirectoryTable.translations.json';

const { addTranslations, useTranslation } = i18nNsFactory(
  'input-data-directory-table',
);
addTranslations(translations);

export interface InputDataDirectoryFilterProps extends DirectoryFilterProps {
  dataManager?: string;
  outputCode?: string;
}

export const InputDataDirectoryFilter = forwardRef<
  FormInstance,
  InputDataDirectoryFilterProps
>((props, ref) => {
  const { t } = useTranslation();
  const { dataManager, outputCode, ...rest } = props;
  const { data: groupsWithDescriptions, isFetching } =
    useDataObjectGroupsWithDescriptionsQuery({
      active: false,
      groupType: DataObjectGroupType.O,
    });
  const options = useGroupDescriptionOptions(groupsWithDescriptions);

  const filterFields = useMemo(
    () => [
      {
        name: 'dataManager',
        label: t('menu.dataManager'),
        initialValue: dataManager,
        input: () => <DataManagerSelect />,
      },
      {
        name: 'outputCode',
        label: t('menu.output'),
        initialValue: outputCode,
        input: () => (
          <GroupOrDescriptionSelect options={options} isLoading={isFetching} />
        ),
      },
    ],
    [dataManager, isFetching, options, outputCode, t],
  );

  return <DirectoryFilter ref={ref} {...rest} fields={filterFields} />;
});
